import {memoize} from '@servicenow/ui-internal';

const getParts = memoize(
	value => {
		const slashIndex = value.indexOf('/');

		if (slashIndex === -1) return [];

		const [delimeter, pathSplitIndex] = getDelimeterDetail(value);

		return [
			value.substring(1, slashIndex),
			value.substring(
				slashIndex + 1,
				pathSplitIndex === -1
					? value.length
					: delimeter === '.'
					? pathSplitIndex
					: pathSplitIndex + 1
			),
			pathSplitIndex !== -1 ? value.substring(pathSplitIndex + 1) : ''
		];
	},
	{profileName: 'getParts'}
);

const getDelimeterDetail = selector => {
	const {length: selectorLength} = selector;
	for (let i = 0; i < selectorLength; i++) {
		const value = selector.charAt(i);
		if (value === '.') return [value, i];
		if (value === '[') return [value, i - 1];
	}

	return ['', -1];
};

/**
 * Returns property selector parts, id and property name
 * @function getSelectorParts
 * @private
 *
 * @param {Object} mappings - A object that will contain mappings
 * @returns {Array} - Property selector parts, id, property name and path
 */
export default function getSelectorParts(value) {
	if (typeof value !== 'string') return [];
	if (value[0] !== '@') return [];

	return getParts(value);
}
